import React from "react";
import "../styles/Pmsby.css";
import PmsbyBanner from "../assets/photos/pmsby-banner.png";

function Pmsby() {
  return (
    <div className="pmsby-wrapper">

      {/* HERO */}

      <section className="pmsby-hero">
        <h1>Pradhan Mantri Suraksha Bima Yojana (PMSBY)</h1>
        <p>
          Affordable accident insurance scheme providing financial security
          against accidental death and disability.
        </p>

        <div className="gov-badge">
          Government Social Security Scheme
        </div>
      </section>


      {/* QUICK HIGHLIGHTS */}

      <section className="pmsby-highlights">

        <div className="highlight-card">
          <h3>Entry Age</h3>
          <p>18 – 70 Years</p>
        </div>

        <div className="highlight-card">
          <h3>Premium</h3>
          <p>₹20 per Year</p>
        </div>

        <div className="highlight-card">
          <h3>Coverage</h3>
          <p>₹2 Lakh</p>
        </div>

        <div className="highlight-card">
          <h3>Policy Period</h3>
          <p>1 Year (Renewable)</p>
        </div>

      </section>


      {/* ABOUT SCHEME */}

      <section className="pmsby-about">

        <div className="about-left">

          <h2>About PMSBY</h2>

          <p>
            Pradhan Mantri Suraksha Bima Yojana (PMSBY) is an accident
            insurance scheme providing coverage in case of accidental
            death or disability.
          </p>

          <p>
            The scheme is administered through insurance companies
            and implemented by banks to ensure affordable financial
            protection to citizens.
          </p>

          <h2>Details</h2>

          <p>An Accident Insurance Scheme offering accidental death and disability cover for death or disability on account of an accident.
             Premium:
             Rs.20/- per annum per member. The premium will be deducted from the account holder’s bank / Post office account through ‘auto debit’ facility on or before 1st June of each annual coverage period under the scheme.
             Coverage Duration:
             Coverage under PMJJBY is valid for one year from 1st June to 31st May on payment of annual premium.
             Accident cover assurance termination:
             The accident cover of the member shall terminate / be restricted accordingly on any of the following events:
             •	On attaining age 70 years (age nearer birth day).
             •	Closure of account with the Bank or insufficiency of balance to keep the insurance in force.
             In case a member is covered under PMSBY through more than one account and premium is received by insurance company inadvertently, insurance cover will be restricted to Rs. 2 lakh.
            </p>

        </div>


        <div className="about-right">

        <div className="info-box-img">
        <a href="https://www.financialservices.gov.in/beta/en/pmsby"><img src={PmsbyBanner} alt="info-pm-suraksha"/></a>
        <h6>Click the Banner to Know more.</h6>

        </div>

          <div className="info-box-pmsby">
            <h4>Insurance Company</h4>
            <p>The New India Assurance Company Ltd.</p>
          </div>

          <div className="info-box-pmsby">
            <h4>Plan Type</h4>
            <p>Personal Accidental Insurance</p>
          </div>

          <div className="info-box-pmsby">
            <h4>Policy Tenure</h4>
            <p>1 Year (Renewable)</p>
          </div>

        </div>

      </section>



      {/* BENEFITS */}

      <section className="pmsby-benefits">

        <h2>Benefits of the Scheme</h2>

        <div className="benefit-grid">

          <div className="benefit-card">
            <h3>Accidental Death</h3>
            <p>Coverage up to ₹2,00,000</p>
          </div>

          <div className="benefit-card">
            <h3>Permanent Disability</h3>
            <p>Coverage up to ₹2,00,000</p>
          </div>

          <div className="benefit-card">
            <h3>Loss of One Eye / Limb</h3>
            <p>Coverage up to ₹1,00,000</p>
          </div>

        </div>

      </section>



      {/* POLICY TIMELINE */}

      <section className="pmsby-timeline">

        <h2>Policy Coverage Period</h2>

        <div className="timeline">

          <div className="timeline-step">
            <h3>1 June</h3>
            <p>Policy Start</p>
          </div>

          <div className="timeline-line"></div>

          <div className="timeline-step">
            <h3>31 May</h3>
            <p>Policy End</p>
          </div>

        </div>

      </section>



      {/* PREMIUM */}

      <section className="pmsby-premium">

        <h2>Premium Details</h2>

        <div className="premium-card">

          <h3>₹20 per year</h3>

          <p>
            Premium amount will be automatically debited from the
            subscriber's Savings Bank account every year.
          </p>

        </div>

      </section>



      {/* CLAIM PROCEDURE */}

      <section className="pmsby-claim">

        <h2>Claim Procedure</h2>

        <div className="claim-steps">

          <div className="claim-card">
            <h3>Step 1</h3>
            <p>Inform the nearest bank branch.</p>
          </div>

          <div className="claim-card">
            <h3>Step 2</h3>
            <p>Submit claim form and required documents.</p>
          </div>

          <div className="claim-card">
            <h3>Step 3</h3>
            <p>Bank forwards claim to insurance company.</p>
          </div>

          <div className="claim-card">
            <h3>Step 4</h3>
            <p>Insurance company processes settlement.</p>
          </div>

        </div>

      </section>



      {/* ICON GRID */}

      <section className="pmsby-icons">

        <div className="icon-card">
          <h3>🛡 Protection</h3>
          <p>Accident insurance coverage</p>
        </div>

        <div className="icon-card">
          <h3>👨‍👩‍👧 Family Security</h3>
          <p>Financial protection for family</p>
        </div>

        <div className="icon-card">
          <h3>💰 Affordable</h3>
          <p>Only ₹20 annual premium</p>
        </div>

        <div className="icon-card">
          <h3>🏦 Bank Enrollment</h3>
          <p>Easy enrollment through bank</p>
        </div>

      </section>



      {/* FAQ */}

      <section className="pmsby-faq">

        <h2>Frequently Asked Questions</h2>

        <div className="faq-item">
          <h4>Who can enroll in PMSBY?</h4>
          <p>Anyone between 18 and 70 years having a Savings Bank account.</p>
        </div>

        <div className="faq-item">
          <h4>What is the annual premium?</h4>
          <p>The premium is ₹20 per member per year.</p>
        </div>

        <div className="faq-item">
          <h4>How long is the policy valid?</h4>
          <p>The policy is valid for one year and can be renewed annually.</p>
        </div>

        <div className="faq-item">
          <h4>Where to submit claims?</h4>
          <p>Please contact the nearest bank branch for claim procedure.</p>
        </div>

      </section>


      {/* DOWNLOAD FORM */}

      <section className="pmsby-download">

        <a href="/forms/pmsby-form.pdf" className="download-btn">
          Download Form
        </a>

      </section>

    </div>
  );
}

export default Pmsby;